import { render, staticRenderFns } from "./ProductGroupGrid-gt3.vue?vue&type=template&id=2abbe422&scoped=true"
import script from "./ProductGroupGrid-gt3.vue?vue&type=script&lang=js"
export * from "./ProductGroupGrid-gt3.vue?vue&type=script&lang=js"
import style0 from "./ProductGroupGrid-gt3.vue?vue&type=style&index=0&id=2abbe422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbe422",
  null
  
)

export default component.exports